import { openBlock as t, createElementBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
};
function l(s, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M4 6.667h8m-8 6.666h8M8.004 2.667v8"
    }, null, -1)
  ])]);
}
const d = { render: l };
export {
  d as default,
  l as render
};
